<template>
    <div class="mt-lg-3 mt-1 pt-3 pb-0 px-3">
        <b-card class="card-material" style="max-width: 60rem;">
            <h4>
                <a :href="rev1" target="_blank">TDC Manual (Rev. 1)</a>
                <pre><i class="small" style="color: grey;">13 November 2018</i></pre>
            </h4>
            <p class="card-text">
                The Temperature Difference Controller ESDP TDC V1 facilitates efficient use and
                function control of your solar or heating system. The device is impressive most of
                all for its functionality and simple, almost self-explanatory operation.
                <br><br><span style="color: grey;"><i class="fa fa-file-pdf-o"></i> PDF ~4.3MB</span>
            </p>
        </b-card>

        <b-card class="card-material" style="max-width: 60rem;">
            <h4>
                <a :href="rev2" target="_blank">TDC Manual (Rev. 2)</a>
                <pre><i class="small" style="color: grey;">9 May 2019</i></pre>
            </h4>
            <p class="card-text">
                The Temperature Difference Controller ESDP TDC V2 facilitates efficient use and
                function control of your solar or heating system. The device is impressive most of
                all for its functionality and simple, almost self-explanatory operation.
                <br><br><span style="color: grey;"><i class="fa fa-file-pdf-o"></i> PDF ~3.3MB</span>
            </p>
        </b-card>

        <b-card class="card-material" style="max-width: 60rem;">
            <h4 class="pb-2">
                <h4>Create your first device</h4>
            </h4>
            <p class="card-text pb-2">
                Below is a short video describing the necessary steps for creating a virtual device.
                This is the first thing you must do before trying to link your device to your online account.
            </p>
            <p class="card-text" ref="youtubeContainer">
                <youtube v-if="youtubeWidth" :width="youtubeWidth" :height="youtubeHeight" :video-id="'a4HpAy1BtVc'" :resize='true'
                         :fitParent="true"></youtube>
            </p>
        </b-card>

        <b-card class="card-material" style="max-width: 60rem;">
            <h4 class="pb-2">
                <h4>Connecting your device to Wi-Fi</h4>
            </h4>
            <p class="card-text pb-2">
                Now that we have added a virtual device we need to connect our physical device to a Wi-Fi access point before being able to link it to
                our online account.
            </p>
            <p class="card-text" ref="youtubeContainer">
                <youtube v-if="youtubeWidth" :width="youtubeWidth" :height="youtubeHeight" :video-id="'K1elSuzjI7E'" :resize='true'
                         :fitParent="true"></youtube>
            </p>
        </b-card>

        <b-card class="card-material" style="max-width: 60rem;">
            <h4 class="pb-2">
                <h4>Linking your device to your online account</h4>
            </h4>
            <p class="card-text pb-2">
                After having connected your device to a Wi-Fi access point the next thing to do is linking it to your online account.
                Watch the video below for more details.
            </p>
            <p class="card-text" ref="youtubeContainer">
                <youtube v-if="youtubeWidth" :width="youtubeWidth" :height="youtubeHeight" :video-id="'Pc1hdd7OdNI'" :resize='true'
                         :fitParent="true"></youtube>
            </p>
        </b-card>

        <b-card class="card-material" style="max-width: 60rem;">
            <h4 class="pb-2">
                <h4>Set up device variant and configure modules</h4>
            </h4>
            <p class="card-text pb-2">
                Now that your device is linked to your account you can setup its working mode and customize it to fulfill your systems' needs.
            </p>
            <p class="card-text" ref="youtubeContainer">
                <youtube v-if="youtubeWidth" :width="youtubeWidth" :height="youtubeHeight" :video-id="'-LT3j6bqqm8'" :resize='true'
                         :fitParent="true"></youtube>
            </p>
        </b-card>
    </div>
</template>

<script>
    import {Youtube} from 'vue-youtube'

    export default {
        name: "Documents",

        components: {
            Youtube
        },

        data() {
            return {
                rev1: 'https://things.al/products/pdf/tdc_rev_1.pdf',
                rev2: 'https://things.al/products/pdf/tdc_rev_2.pdf',
                youtubeWidth: null,
                youtubeHeight: null
            }
        },

        mounted() {
            this.youtubeWidth = this.$refs.youtubeContainer.clientWidth; //we get width from container to prevent glitch when reloading window
            this.youtubeHeight = this.youtubeWidth / 1.777777778;
        }
    }
</script>

<style scoped>
</style>